
import React from 'react';
import { DiagnosticResult } from './types';

interface RLSPoliciesSectionProps {
  results: DiagnosticResult;
}

export const RLSPoliciesSection: React.FC<RLSPoliciesSectionProps> = ({ results }) => {
  return (
    <div className="bg-muted p-4 rounded-md">
      <h3 className="font-medium mb-2">RLS Policies</h3>
      <div className="text-sm">
        {results.rls_policies.length > 0 ? (
          <pre className="bg-background p-2 rounded text-xs overflow-auto max-h-24">
            {JSON.stringify(results.rls_policies, null, 2)}
          </pre>
        ) : (
          <p className="text-red-500">No RLS policies found for connections_new</p>
        )}
      </div>
    </div>
  );
};
